import axios from 'axios'
import {ClientChangePasswordEndPoint} from '../../../config/AppServerConfig'
import {GlobalConfig} from "../../../Services/Helper/GlobalConfig";

class ClientChangePasswordServices {

    static ChangePassword( data) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.put(ClientChangePasswordEndPoint,data,config)
    }
}

export {ClientChangePasswordServices}
